<template>
  <span
    class="icon-dimension position-relative d-flex justify-content-center align-items-center rounded-circle shadow-sm"
    :style="{
      backgroundColor: '#fff',
      // color: userColor,
      border: '1px solid #ccc',
      width: size + 'px',
      height: size + 'px'
    }"
  >
    <span
      class="initials text-dark fw-bold"
      :style="{ fontSize: fontSize + 'rem' }"
    >
      {{ userInitials }}
    </span>
  </span>
</template>

<script>
//import { getUserColor } from "@/helpers/colors";

export default {
  name: "UserIcon",
  props: {
    fullname: {
      type: String,
      required: true
    },
    onid: {
      type: String,
      required: false
    },
    size: {
      type: [Number, String],
      default: 48
    },
    fontSize: {
      type: [Number, String],
      default: "0.8"
    }
  },
  computed: {
    // userColor() {
    //   return getUserColor(this.onid);
    // },
    userInitials() {
      const parts = this.fullname.trim().split(/\s+/);
      const first = parts[0]?.[0]?.toUpperCase() || "";
      const last =
        parts.length > 1 ? parts[parts.length - 1][0]?.toUpperCase() : "";
      return first + last;
    }
  },
  mounted() {}
};
</script>

<style scoped>
.icon-dimension {
  font-size: 0.9rem;
}

.initials {
  font-size: 0.8rem;
}
</style>
